import analytics from '../../../utils/cdpAnalytics'

export function updateVideoClipTimes(videoNode, nodePos, startTime, endTime) {
  const { tr } = window.view.state
  let isClipped = false
  if (startTime !== 0 || endTime - startTime !== videoNode.attrs.fullDuration) {
    isClipped = true
  }
  tr.setNodeMarkup(nodePos, null, {
    ...videoNode.attrs, start: startTime, end: endTime, isClipped,
  })
  window.view.dispatch(tr)
  const videoAttrs = videoNode.attrs
  analytics.track('Edit Video', {
    youtubeId: videoAttrs.youtubeId,
    title: videoAttrs.title,
    channelTitle: videoAttrs.channelTitle,
    thumbnail: videoAttrs.thumbnail.src,
    fullDuration: videoAttrs.fullDuration,
    start: startTime,
    end: endTime,
    isClipped,
    clipDuration: endTime - startTime,
  })
}
